import { useCallback, useEffect, useRef, useState } from "react";

export const useSim = (init) => {
  const [s, setS] = useState(init);
  const ref = useRef(s);
  const set = useCallback((v) => { ref.current = typeof v === "function" ? v(ref.current) : v; setS(ref.current); }, []);
  return [s, set, ref];
};

export const useWin = (won, onSuccess) => { useEffect(() => { if (won) onSuccess(); }, [won, onSuccess]); };

export const useLoop = (fn, running) => {
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(() => {
    if (!running) return undefined;
    let id, last = performance.now();
    const tick = (t) => { ref.current(Math.min(0.05, (t - last) / 1000)); last = t; id = requestAnimationFrame(tick); };
    id = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(id);
  }, [running]);
};

export const Slider = ({ label, value, min, max, step = 1, onChange, testid, unit = "" }) => (
  <label className="block text-sm" data-testid={`${testid}-wrap`}>
    <span className="flex justify-between font-semibold text-[#0A192F]"><span>{label}</span><span className="text-[#007A8A] tabular-nums">{Number(value).toFixed(step >= 1 ? 0 : step >= 0.5 ? 1 : 2)}{unit}</span></span>
    <input type="range" min={min} max={max} step={step} value={value} onChange={(e) => onChange(Number(e.target.value))}
      className="w-full accent-[#007A8A] mt-1" data-testid={testid} />
  </label>
);

export const SimBtn = ({ children, onClick, testid, tone = "teal", disabled }) => (
  <button onClick={onClick} disabled={disabled} data-testid={testid}
    className={`rounded-full px-4 py-2 text-sm font-bold transition-[transform,background-color] active:scale-95 disabled:opacity-50 ${tone === "teal" ? "bg-[#007A8A] text-white hover:bg-[#006673]" : tone === "pink" ? "bg-[#FF2E63] text-white hover:bg-[#e0234f]" : "bg-white border border-slate-200 text-[#0A192F] hover:bg-slate-50"}`}>{children}</button>
);

export const Stage = ({ children, w = 600, h = 340, onClick, testid = "sim-stage", dark = false }) => (
  <svg viewBox={`0 0 ${w} ${h}`} onClick={onClick} data-testid={testid}
    className={`w-full rounded-2xl border ${dark ? "bg-[#0A192F] border-[#0A192F]" : "bg-gradient-to-b from-[#F7FAFF] to-[#E8F0FE] border-slate-200"}`}>{children}</svg>
);

export const Readout = ({ items }) => (
  <div className="flex flex-wrap gap-2" data-testid="sim-readout">{items.map(([k, v, tone]) => (
    <span key={k} className={`rounded-full px-3 py-1 text-xs font-bold ${tone === "bad" ? "bg-[#FFE4EA] text-[#C2163F]" : tone === "good" ? "bg-[#DDF6E8] text-[#137A43]" : "bg-white border border-slate-200 text-[#0A192F]"}`}>{k}: {v}</span>))}</div>
);
